<template>
    <div class='marking content-view'>
        <h2 class='fs-24 text-center fc-theme'>抖音验号</h2>

        <top-price code="tiktokurl"></top-price>


        <div style='padding-top: 40px;'>
            <steps @getInfo='getInfo' @updateQrCodeList='updateQrCodeList' @updateQueryList='updateQueryList' />
        </div>

        <div v-show='info.name'>
            <!-- 基本信息 -->
            <info-basic :info-data='info' />

            <!-- 账号视频作品分析 -->
            <info-work-analysis :info-data='info' />

            <!-- 下载详情 -->
            <!--<div style='padding: 40px 0; text-align: center;'>-->
            <!--    <p style='padding-bottom: 6px; color: #FF6464;'>点击下载详情按钮获取更多详细信息</p>-->
            <!--    <el-button type='danger'>下载详情</el-button>-->
            <!--</div>-->
        </div>

        <!-- 查询记录 -->
        <record-query ref="recordQueryRef" />

        <!-- 二维码获取记录 -->
        <record-qr-code ref="recordQrCodeRef" />
    </div>
</template>

<script>
import { mapState } from 'vuex'
import Steps from './_components/Steps'
import InfoBasic from './_components/InfoBasic'
import InfoWorkAnalysis from './_components/InfoWorkAnalysis'
import RecordQuery from './_components/RecordQuery'
import RecordQrCode from './_components/RecordQrCode';
import { defaultInfo } from './defaultInfo'

export default {
    components: {
        Steps,
        InfoBasic,
        InfoWorkAnalysis,
        RecordQuery,
        RecordQrCode,
    },
    data() {
        return {
            pricePreMonth: {},
            info: defaultInfo,
        }
    },
    computed: mapState(['userData', 'phone']),
    mounted() {

    },
    methods: {
        async priceLimit() {
            const data = await this.$fetch('/tool/apps/api-info', {name: 'tiktokurl'})
            this.pricePreMonth = data.data
        },

        // 获取到数据了
        getInfo(info) {
            console.log({info})
            this.info = info;
        },

        // 更新二维码记录
        updateQrCodeList() {
            this.$refs.recordQrCodeRef.searchSubmit();
        },

        // 更新查询记录
        updateQueryList() {
            this.$refs.recordQueryRef.searchSubmit();
        },
    }
}
</script>

<style scoped>

</style>
